module.exports = __webpack_public_path__ + "static/media/img_zendy04.27715bbd.jpeg";